import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '../services/logger.service';
import { GlobalModalService } from '../shared/global-modal/global-modal.service';
import { ErrorService } from '../services/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          const logger = this.injector.get(LoggerService);
          const modal = this.injector.get(GlobalModalService);
          const errorService = this.injector.get(ErrorService);
          // Dejar pasar 401 al AuthInterceptor y flujos propios
          if (error.status === 401) {
            return throwError(() => error);
          }

          const skipModal = (req.headers.get('x-skip-error-modal') || '').toString().toLowerCase() === 'true';

          const message = errorService.extractMessage(error);
          const title = this.getTitleByStatus(error.status);

          logger.error('HTTP Error', { url: req.url, status: error.status, message, error: error.error });

          if (!skipModal) {
            modal.showError(title, message);
          }

          return throwError(() => error);
        } else {
          // Error no-HTTP
          const logger = this.injector.get(LoggerService);
          const modal = this.injector.get(GlobalModalService);
          logger.error('Unknown error', error);
          modal.showError('Error inesperado', 'Se produjo un error no controlado.');
          return throwError(() => error);
        }
      })
    );
  }

  private getTitleByStatus(status: number): string {
    if (status === 0) return 'Conexión fallida';
    if (status >= 500) return 'Error del servidor';
    if (status >= 400) return 'Solicitud inválida';
    return 'Error';
  }
}
